import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Sidebar from './Sidebar';

function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // On desktop (>= 1024px), sidebar starts open
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setSidebarOpen(true);
      } else {
        setSidebarOpen(false);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => setSidebarOpen((v) => !v);
  const closeSidebar = () => {
    if (window.innerWidth < 1024) setSidebarOpen(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)' }}>
      <Navbar onToggleSidebar={toggleSidebar} sidebarOpen={sidebarOpen} />
      <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />

      {/* Main content */}
      <main
        style={{
          marginTop: 'var(--navbar-height)',
          marginLeft: sidebarOpen && window.innerWidth >= 1024 ? 'var(--sidebar-width)' : 0,
          transition: 'margin-left 0.25s ease',
          minHeight: 'calc(100vh - var(--navbar-height))',
          padding: '24px',
        }}
        id="main-content"
      >
        <Outlet />
      </main>

      <style>{`
        @media (max-width: 1023px) {
          #main-content {
            margin-left: 0 !important;
            padding: 16px;
          }
        }
      `}</style>
    </div>
  );
}

export default Layout;
